/** @format */

import React, { PureComponent } from 'react';
import Order from '../../interfaces/forms/Order';
import Filter from '../../interfaces/forms/Filter';
import { ListPropsInterface } from '../../modules/lib/ListPropsInterface';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { FilterManager } from '../../modules/filter/FilterManager';
import { Auth, tokenInfo } from '../../modules/auth/Auth';
import { FilterReducerFieldName, FilterReducers } from '../../modules/filter/FilterReducers';
import { FilterListReducerFieldName } from '../../modules/filter/FilterListReducers';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import PaperedTable from '../../components/Table/PaperedTable';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { StorageMsisdnSuperUserItem } from './views/StorageMsisdnSuperUserItem';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { PlatformMsisdnPoolNumberCollectionInterface } from '../../interfaces/collections/PlatformMsisdnPoolNumberCollectionInterface';
import Pager from '../../components/Adescom/PagerRange';
import { TableFooter } from '@material-ui/core';
import FilterList from '../../components/Filter/FilterList';
import { IccidMvnoStatusHelper } from '../lib/search/IccidMvnoStatusHelper';
import { IndicatedRangeLoader } from '../../modules/indicated-range/IndicatedRangeLoader';
import { StorageMsisdnToCsv } from '../../modules/storage/StorageMsisdnToCsv';
import { StorageMsisdnPartnerView } from './views/StorageMsisdnPartnerView';
import { PlatformResellerLoader } from '../../modules/platformreseller/PlatformResellerLoader';
import { history } from '../../core/history';
import { roles, UserRoleHelper } from '../../helpers/UserRoleHelper';
import { PlatformIccidMsisdnIpPoolReducerAction, PlatformIccidMsisdnIpPoolReducerType } from '../../modules/iccid/PlatformIccidMsisdnIpPoolReducer';
import { MsisdnChangeOwner } from './msisdn/MsisdnChangeOwner';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';
import {NotificationHelper} from "../../helpers/NotificationHelper";

interface StorageMsisdnStateInterface {
    poolNumbers: PlatformMsisdnPoolNumberCollectionInterface | null;
    orders: Array<Order>;
    filters: Array<Filter>;
    showClearFilterButton: boolean;
    searchSendWithFitler: boolean;
    activeRow: number;
}

class StorageMsisdn extends PureComponent<ListPropsInterface, StorageMsisdnStateInterface> {
    private readonly loaderCall: ItemLoaders;
    private filterManage: FilterManager;
    private readonly iccidStatusHelper: IccidMvnoStatusHelper;
    private indicatedRangeLoader: IndicatedRangeLoader;

    constructor(props: ListPropsInterface, context: StorageMsisdnStateInterface) {
        super(props, context);

        this.state = {
            poolNumbers: null,
            orders: [],
            filters: [],
            activeRow: 0,
            searchSendWithFitler: false,
            showClearFilterButton: false,
        };
        this.loaderCall = new ItemLoaders(this.props.dispatch);
        this.filterManage = new FilterManager();
        this.iccidStatusHelper = new IccidMvnoStatusHelper();
        this.indicatedRangeLoader = new IndicatedRangeLoader(this.loaderCall);
    }

    componentDidMount(): void {
        this.setDefaultFilter((): void => {
            this.firstLoad();
        });
        this.indicatedRangeLoader.loadIndicatedRange({
            filters: [
                { name: 'typeResource', value: 'msisdn' },
                { name: 'typeSystem', value: 'mvno' },
            ],
            orders: [{ name: 'mainname', value: 'asc' }],
            callback: (): void => {},
        });
    }

    componentDidUpdate(prevProps: Readonly<ListPropsInterface>, prevState: Readonly<StorageMsisdnStateInterface>, snapshot?: any): void {
        const { dispatch, headerFilterElementHasValue, headerFilterElementName } = this.props;
        if (headerFilterElementName) {
            if (headerFilterElementHasValue) {
                this.filterManage.manageElement(headerFilterElementName, headerFilterElementHasValue);
            } else {
                this.filterManage.manageElement(headerFilterElementName, false);
            }
            this.setState({ showClearFilterButton: this.filterManage.hasManageElement() });
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
            });
        }
    }

    setActiveRow = (id: number): void => {
        const { activeRow } = this.state;
        if (activeRow === id) {
            id = 0;
        }
        this.setState({ activeRow: id });
    };

    clearFilter = (): void => {
        this.setDefaultFilter((): void => {
            const { dispatch } = this.props;
            const { searchSendWithFitler } = this.state;
            dispatch({
                type: FilterReducerFieldName.HEADER_FILTER_MANAGE,
                clearAll: true,
            });
            dispatch({
                type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
            });
            if (searchSendWithFitler) {
                this.firstLoad();
            }
        });
    };

    updateOrderList = (orders: Array<Order>): void => this.setState({ orders: orders }, this.firstLoad);
    updateFilterList = (filters: Array<Filter>): void => this.setState({ filters: filters });

    setDefaultFilter = (callback: () => void): void => {
        this.setState(
            {
                showClearFilterButton: false,
                orders: [{ name: 'msisdn', value: 'asc' }],
                filters: [{ name: 'deleted', value: false }],
            },
            (): void => {
                callback();
            }
        );
    };

    firstLoad = (): void => {
        const { filters, orders, showClearFilterButton } = this.state;
        const { dispatch, showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_msisdn_pool_numbers')),
            'storage_msisdn_loader_items',
            filters,
            orders,
            (items: PlatformMsisdnPoolNumberCollectionInterface): void => {
                this.setState({ poolNumbers: items, searchSendWithFitler: showClearFilterButton });
                showMainLoader(false);
                dispatch({
                    type: FilterListReducerFieldName.HEADER_FILTER_MANAGE,
                    showRender: true,
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    paginationCallbackFunction = (uri: string): void => {
        const { showMainLoader } = this.props;
        showMainLoader(true);
        this.loaderCall.paginationCallWithCallback(
            uri,
            'storage_msisdn_loader_items',
            (items: PlatformMsisdnPoolNumberCollectionInterface): void => {
                this.setState({ poolNumbers: items });
                showMainLoader(false);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    exportToCsv = (): void => {
        const { filters, orders,poolNumbers } = this.state;
        const { showMainLoader,dispatch } = this.props;
        if(poolNumbers && !poolNumbers['hydra:totalItems']) {
            NotificationHelper.notifyError('general:common.no_data_to_export', dispatch);
            return;
        }
        const toCsv = new StorageMsisdnToCsv(
            this.loaderCall,
            this.indicatedRangeLoader,
            new PlatformResellerLoader(this.loaderCall),
            this.iccidStatusHelper
        );
        toCsv.exportToCsv(
            (UserRoleHelper.checkRole(roles.ROLE_PLATFORM_MSISDN_POOL_NUMBER_GET) &&
                !UserRoleHelper.checkRole(roles.ROLE_MSISDN_PLATFORM_POOL_NUMBER_PARTNER_VIEW)) ||
                UserRoleHelper.checkRole(roles.ROLE_SUPERUSER),
            orders,
            filters,
            showMainLoader
        );
    };

    viewCallback = (iri: { uri: string }, event: any): void => this.pushCallback('/msisdn-view' + iri.uri, event);
    viewPoolManager = (iri: { uri: string }, event: any): void => this.pushCallback('/msisdn-pool-manage', event);

    pushCallback = (uri: string, event: any): void => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        history.respectModifierPush(event, FormGeneralHelper.getRouteUrl(uri));
    };

    changeOwner = (): void => {
        const { dispatch } = this.props;
        dispatch({
            type: PlatformIccidMsisdnIpPoolReducerAction.IMSI_CHANGE_OWNER_OPEN_DIALOG_ADVANCED,
            openMsisdnChangeOwner: true,
        } as PlatformIccidMsisdnIpPoolReducerType);
    };

    render(): React.ReactNode {
        const { classes } = this.props;
        const { showClearFilterButton, poolNumbers, filters, orders, activeRow } = this.state;
        const tableControlStickyHeader = { root: classes.tableControlStickyHeader };

        return (
            <GridContainer>
                <GridItem xs={12} md={12} lg={12}>
                    <PaperedTable
                        beforeTableContent={
                            <GridContainer>
                                <GridItem xs={12} className={classes.beforeTableContent}>
                                    <CustomTextButtom
                                        callback={this.firstLoad}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.search"
                                        size="lg"
                                    />
                                    {showClearFilterButton && (
                                        <CustomTextButtom
                                            callback={this.clearFilter}
                                            callbackParam={{}}
                                            color="primary"
                                            label="general:common.clear"
                                            size="lg"
                                        />
                                    )}
                                    <CustomTextButtom
                                        callback={this.exportToCsv}
                                        callbackParam={{}}
                                        color="primary"
                                        label="general:common.export_to_csv"
                                        size="lg"
                                    />
                                    {UserRoleHelper.checkRole(roles.ROLE_UPLOAD_MSISDN_POOLS) && (
                                        <CustomTextButtom
                                            callback={this.viewPoolManager}
                                            callbackParam={{ uri: 'no-uri' }}
                                            color="primary"
                                            label="pools:msisdn.pool_manage"
                                            size="lg"
                                        />
                                    )}
                                    {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_MSISDN_POOLS_CHANGE_OWNER_PUT) && (
                                        <React.Fragment>
                                            <CustomTextButtom
                                                callback={this.changeOwner}
                                                callbackParam={{}}
                                                color="primary"
                                                label="pools:sim.owner_change"
                                                size="lg"
                                            />
                                        </React.Fragment>
                                    )}
                                    <FilterList />
                                </GridItem>
                            </GridContainer>
                        }
                    >
                        {((UserRoleHelper.checkRole(roles.ROLE_PLATFORM_MSISDN_POOL_NUMBER_GET) &&
                            !UserRoleHelper.checkRole(roles.ROLE_MSISDN_PLATFORM_POOL_NUMBER_PARTNER_VIEW)) ||
                            UserRoleHelper.checkRole(roles.ROLE_SUPERUSER)) &&
                            poolNumbers && (
                                <StorageMsisdnSuperUserItem
                                    poolItems={poolNumbers['hydra:member']}
                                    viewCallback={this.viewCallback}
                                    classes={classes}
                                    setActiveRow={this.setActiveRow}
                                    activeRow={activeRow}
                                    firstLoad={this.firstLoad}
                                    updateOrderList={this.updateOrderList}
                                    updateFilterList={this.updateFilterList}
                                    filters={filters}
                                    orders={orders}
                                    iccidStatusHelper={this.iccidStatusHelper}
                                    indicatedRangeLoader={this.indicatedRangeLoader}
                                />
                            )}
                        {UserRoleHelper.checkRole(roles.ROLE_MSISDN_PLATFORM_POOL_NUMBER_PARTNER_VIEW) &&
                            !UserRoleHelper.checkRole(roles.ROLE_SUPERUSER) &&
                            poolNumbers && (
                                <StorageMsisdnPartnerView
                                    poolItems={poolNumbers['hydra:member']}
                                    viewCallback={this.viewCallback}
                                    classes={classes}
                                    setActiveRow={this.setActiveRow}
                                    activeRow={activeRow}
                                    firstLoad={this.firstLoad}
                                    updateOrderList={this.updateOrderList}
                                    updateFilterList={this.updateFilterList}
                                    filters={filters}
                                    orders={orders}
                                    iccidStatusHelper={this.iccidStatusHelper}
                                    indicatedRangeLoader={this.indicatedRangeLoader}
                                />
                            )}
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={10}>
                                    {poolNumbers && poolNumbers['hydra:view'] && (
                                        <Pager callback={this.paginationCallbackFunction} views={poolNumbers} />
                                    )}
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </PaperedTable>
                    <MsisdnChangeOwner />
                </GridItem>
            </GridContainer>
        );
    }
}

const stateToProps = (state: { filterReducer: FilterReducers }): object => {
    const { filterReducer } = state;
    if (filterReducer && filterReducer.headerFilterElementName) {
        return {
            headerFilterElementHasValue: filterReducer.headerFilterElementHasValue,
            headerFilterElementName: filterReducer.headerFilterElementName,
        };
    }
    return {};
};

export default compose<any, any>(connect(stateToProps), withStyles(OplAppStyle))(StorageMsisdn);
